import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'ct-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public type: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.type = this.activatedRoute.snapshot.paramMap.get('type');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.type = this.activatedRoute.snapshot.paramMap.get('type');
      }
    });

    if (!this.translateService.currentLang) {
      this.translateService.use('es-ES');
      this.translateService.setDefaultLang('es-ES');
      document.documentElement.lang = 'es';
    }
  }

}
